import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClipboardService } from 'ngx-clipboard';
import { LanguageService } from 'src/app/services/language.service';
import { ErrorDialogData } from '../error-dialog-data';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss'],
  standalone: false
})
export class ErrorDialogComponent implements OnInit {

  /** Confirmation dialog title */
  public title: string = "";
  /** Confirmation dialog message */
  public message: string = "";
  /** Showing list of elements with scrollbar depending on height */
  public elementList: string[] = [];

  public showMoreTitle: string = "";
  public showMoreValue: string = "";
  public showMoreState: boolean = false;
  public copyAnimation: boolean = false;
  private copyAnimationRef = null;

  constructor(public dialogRef: MatDialogRef<ErrorDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: { data: ErrorDialogData },
    public languageService: LanguageService, private clipboardApi: ClipboardService) {

    if (data.data.title) {
      this.title = data.data.title;
    }
    if (data.data.message) {
      this.message = data.data.message;
    }
    if (data.data.elementList) {
      this.elementList = data.data.elementList;
    }
    if (data.data.showMoreTitle) {
      this.showMoreTitle = data.data.showMoreTitle;
    }
    if (data.data.showMoreValue) {
      this.showMoreValue = data.data.showMoreValue
    }
  }


  ngOnInit(): void {
  }

  copyToClipboardClick(): void {
    this.clipboardApi.copyFromContent(this.showMoreValue);
    if (this.copyAnimationRef) {
      clearTimeout(this.copyAnimationRef);
    }
    this.copyAnimation = true;
    setTimeout(() => {
      this.copyAnimation = false;
    }, 2500);
  }
}
